// Portuguese labels and descriptions for the API page. Key = "METHOD /path".
export const TAG_LABELS = {
  auth: "Autenticação (senha)",
  "auth-supabase": "Login com e-mail (Supabase) e autenticador",
  "supabase-mirror": "Cópia no Supabase",
  customers: "Clientes",
  trials: "Testes",
  templates: "Comandos",
  whatsapp: "WhatsApp",
  settings: "Configurações",
  payments: "Pagamentos",
  "payment-accounts": "Contas de pagamento",
  finance: "Financeiro",
  raffle: "Sorteio (Trevo da Sorte)",
  public: "Público",
  dashboard: "Dashboard",
  messages: "Conversas",
  painel: "Painel.fun",
  notifications: "Notificações",
  uploads: "Imagens",
  reminders: "Lembretes",
  coupons: "Cupons",
  analytics: "Geografia",
  system: "Sistema / Atualização",
  queue: "Fila de envio",
  cron: "Tarefas agendadas",
  "customer-prefs": "Preferências do cliente",
  outros: "Saúde do servidor",
};

export const TAG_ORDER = [
  "auth", "auth-supabase", "dashboard", "finance", "payments", "payment-accounts", "raffle", "customers", "painel",
  "trials", "coupons", "whatsapp", "messages", "notifications", "queue", "templates", "reminders", "settings",
  "customer-prefs", "uploads", "analytics", "supabase-mirror", "system", "cron", "public", "outros",
];

export const PUBLIC_PATHS = [
  "POST /api/auth/login", "POST /api/auth/login/verify", "GET /api/auth/methods", "POST /api/auth/email-login",
  "POST /api/auth/email-login/verify", "POST /api/public/trial", "GET /api/public/raffle", "GET /api/uploads/{filename}",
  "POST /api/payments/webhook", "POST /api/payments/mp-webhook", "POST /api/payments/check-status/{customer_id}",
  "GET /api/payments/customer/{customer_id}", "GET /api/payments/painel-link/{customer_id}",
  "GET /api/payments/mp-status/{payment_id}", "POST /api/whatsapp/incoming", "GET /api/", "GET /api/health",
  "GET /api/health/poller", "POST /api/cron/monthly-report",
];

export const DESCRIPTIONS = {
  "POST /api/auth/login": "Entra só com a senha do admin. Devolve o token (access_token). Bloqueado se o login só com senha estiver desligado.",
  "POST /api/auth/login/verify": "Confirma o código de 6 dígitos enviado por e-mail (verificação antiga por e-mail).",
  "GET /api/auth/2fa/status": "Situação da verificação antiga por e-mail.",
  "POST /api/auth/2fa/setup": "Envia o código para ativar a verificação antiga por e-mail.",
  "POST /api/auth/2fa/confirm": "Confirma o código e ativa a verificação antiga por e-mail.",
  "POST /api/auth/2fa/disable": "Desativa a verificação antiga por e-mail (pede a senha).",
  "GET /api/auth/me": "Confere se o token ainda é válido.",
  "POST /api/auth/change-password": "Troca a senha antiga (login só com senha).",
  "GET /api/auth/methods": "Quais formas de login estão ligadas: e-mail (Supabase) e/ou só senha.",
  "POST /api/auth/email-login": "Login com e-mail e senha do Supabase. Se o autenticador estiver ativo, devolve requires_totp e challenge_id em vez do token.",
  "POST /api/auth/email-login/verify": "Envia o código de 6 dígitos do app autenticador junto com o challenge_id e recebe o token.",
  "GET /api/auth/supabase/status": "E-mail de acesso ligado, autenticador ativo e se o login só com senha está permitido.",
  "POST /api/auth/supabase/account": "Cria (ou liga) a conta de e-mail e senha no Supabase usada para entrar.",
  "POST /api/auth/supabase/totp/start": "Começa o cadastro do app autenticador: devolve QR code, chave e enroll_id.",
  "POST /api/auth/supabase/totp/confirm": "Confirma o primeiro código do app e ativa a verificação em 2 etapas.",
  "POST /api/auth/supabase/totp/disable": "Desativa o autenticador (pede senha e código atual).",
  "PUT /api/auth/supabase/legacy": "Liga/desliga o login só com senha. Só desliga com o autenticador ativo.",
  "GET /api/supabase/mirror": "Situação da cópia de clientes, testes e logs no Supabase (última cópia, quantidades, erro).",
  "POST /api/supabase/mirror/run": "Copia agora clientes, testes, logs e usuários do painel para o Supabase.",
  "POST /api/uploads": "Envia uma imagem (comandos, notificações) e devolve a URL.",
  "GET /api/uploads/{filename}": "Baixa uma imagem enviada.",
  "POST /api/customers/set-whatsapp-by-painel": "Cria/atualiza um cliente pelo login do painel e fixa o WhatsApp dele.",
  "GET /api/customers": "Lista os clientes salvos.",
  "POST /api/customers": "Cadastra um cliente.",
  "GET /api/customers/{customer_id}": "Dados de um cliente.",
  "PUT /api/customers/{customer_id}": "Atualiza um cliente.",
  "DELETE /api/customers/{customer_id}": "Remove um cliente.",
  "GET /api/trials": "Lista os testes criados.",
  "POST /api/trials": "Cria um teste no painel.fun e salva.",
  "POST /api/trials/test-login": "Testa o login no painel.fun (resolve o captcha).",
  "GET /api/templates": "Lista os comandos do bot. Também ficam salvos no Mongo Atlas.",
  "POST /api/templates": "Cria um comando (salvo também no Mongo Atlas).",
  "GET /api/templates/bot-diagnostics": "Atividade recente do bot para descobrir por que um comando não respondeu.",
  "PUT /api/templates/{template_id}": "Edita um comando (atualiza também no Mongo Atlas).",
  "DELETE /api/templates/{template_id}": "Apaga um comando (apaga também no Mongo Atlas).",
  "GET /api/whatsapp/status": "Se o WhatsApp está conectado.",
  "GET /api/whatsapp/qr": "QR code para conectar o WhatsApp.",
  "POST /api/whatsapp/pairing-code": "Gera o código de 8 letras para conectar pelo número.",
  "POST /api/whatsapp/send": "Envia mensagem respeitando a fila e o anti-duplicado.",
  "POST /api/whatsapp/send-immediate": "Envia na hora, sem fila (use só em emergência).",
  "POST /api/whatsapp/logout": "Desconecta o WhatsApp.",
  "GET /api/whatsapp/groups": "Lista os grupos do WhatsApp.",
  "GET /api/whatsapp/channels": "Lista os canais do WhatsApp.",
  "POST /api/whatsapp/groups/send": "Envia texto e/ou imagem para um grupo.",
  "POST /api/whatsapp/channels/send": "Envia texto e/ou imagem para um canal.",
  "POST /api/whatsapp/groups/send-image": "Envia imagem para um grupo.",
  "POST /api/whatsapp/channels/send-image": "Envia imagem para um canal.",
  "POST /api/whatsapp/restart": "Reinicia o serviço do WhatsApp.",
  "POST /api/whatsapp/incoming": "Uso interno: o serviço do WhatsApp avisa que chegou mensagem.",
  "GET /api/settings": "Todas as configurações (também copiadas para o Mongo Atlas).",
  "PUT /api/settings": "Salva configurações (também copiadas para o Mongo Atlas).",
  "GET /api/settings/discounts": "Descontos por evento.",
  "PUT /api/settings/discounts/{event_key}": "Liga/desliga e define o % de desconto de um evento.",
  "GET /api/payments": "Lista os pagamentos.",
  "POST /api/payments": "Cria link de pagamento de renovação (com cupom e trevos opcionais).",
  "POST /api/payments/test-link": "Cria um link de teste de R$ 1,00.",
  "POST /api/payments/webhook": "Aviso do InfinitePay de pagamento aprovado.",
  "POST /api/payments/resend-notification/{payment_id}": "Reenvia a mensagem de renovação confirmada.",
  "POST /api/payments/reprocess/{payment_id}": "Tenta renovar de novo um pagamento.",
  "GET /api/payments/diagnostics": "Diagnóstico dos pagamentos recentes.",
  "GET /api/payments/trace/{key}": "Linha do tempo completa de um pagamento.",
  "POST /api/payments/check-status/{customer_id}": "Página /pay confere se o pagamento foi aprovado.",
  "POST /api/payments/poll-now": "Força a verificação dos pagamentos pendentes.",
  "GET /api/payments/customer/{customer_id}": "Dados da página de pagamento /pay de um cliente.",
  "GET /api/payments/painel-link/{customer_id}": "Link de pagamento do painel.fun para o cliente.",
  "GET /api/payments/mp-status/{payment_id}": "Situação do Pix do Mercado Pago.",
  "POST /api/payments/mp-webhook": "Aviso do Mercado Pago.",
  "GET /api/payment-accounts": "Contas InfinitePay / Mercado Pago.",
  "PUT /api/payment-accounts": "Salva as contas de pagamento.",
  "POST /api/payment-accounts/{account_id}/test": "Testa uma conta de pagamento.",
  "GET /api/finance/summary": "Resumo do mês (?month=AAAA-MM): recebido, créditos, e o Trevo da Sorte (vendas de trevo, custo do prêmio em créditos e resultado).",
  "GET /api/finance/customer/{customer_id}/payments": "Pagamentos e comprovantes de um cliente.",
  "GET /api/finance/report.pdf": "Relatório do mês em PDF.",
  "POST /api/finance/report/send": "Envia o relatório do mês.",
  "GET /api/raffle": "Sorteio atual: rodada, situação (aberto/encerrado), participantes, trevos, configuração e histórico.",
  "PUT /api/raffle/settings": "Configura o sorteio: ativo, preço do trevo, meses de prêmio, coringa, iniciar novo automaticamente (auto_restart) e renovar ganhador automaticamente (auto_renew).",
  "PUT /api/raffle/participant-name": "Troca o nome exibido de um participante.",
  "POST /api/raffle/new-round": "Inicia um novo sorteio depois que o atual foi realizado.",
  "POST /api/raffle/entries": "Adiciona um cliente ao sorteio atual: {customer: login ou ID, clovers: 1-10}.",
  "DELETE /api/raffle/entries/{entry_id}": "Remove trevos adicionados manualmente.",
  "POST /api/raffle/draw": "Realiza o sorteio agora (renova o ganhador se a renovação automática estiver ligada).",
  "GET /api/public/raffle": "Página pública /trevo: participantes, data do sorteio e ganhadores.",
  "POST /api/public/trial": "Formulário público /teste: cria teste e devolve o acesso.",
  "GET /api/dashboard/stats": "Números do Dashboard.",
  "GET /api/dashboard/activity": "Atividade recente.",
  "GET /api/dashboard/attribution": "Quais mensagens mais trazem pagamentos.",
  "GET /api/dashboard/revenue-by-day": "Receita por dia.",
  "GET /api/dashboard/balances": "Saldo do painel.fun e do 2Captcha.",
  "GET /api/messages": "Mensagens de uma conversa.",
  "GET /api/messages/conversations": "Lista de conversas.",
  "GET /api/painel/users": "Usuários do painel.fun (force=true atualiza na hora).",
  "GET /api/painel/users/{user_id}/notifications": "Notificações planejadas e enviadas de um usuário.",
  "POST /api/painel/users/refresh": "Atualiza agora a lista do painel.fun.",
  "GET /api/painel/status": "Situação da conexão com o painel.fun.",
  "GET /api/painel/test-connection": "Testa o login no painel.fun.",
  "POST /api/painel/test-connection": "Testa o login no painel.fun com os dados digitados.",
  "POST /api/painel/renew": "Renova um usuário do painel manualmente.",
  "GET /api/painel/package-ids": "Pacotes do painel.",
  "GET /api/painel/debug-sample": "Exemplo bruto de usuário do painel (diagnóstico).",
  "GET /api/painel/expiring": "Quem receberia aviso de vencimento agora.",
  "POST /api/painel/notify-now": "Roda os avisos de vencimento agora.",
  "GET /api/painel/expired": "Usuários vencidos com WhatsApp.",
  "POST /api/painel/notify-expired": "Envia aviso para os vencidos.",
  "GET /api/notifications": "Modelos de notificação.",
  "GET /api/notifications/deliveries": "Envios recentes.",
  "GET /api/notifications/dedup-log": "Envios bloqueados pelo anti-duplicado.",
  "POST /api/notifications/deliveries/{delivery_id}/retry": "Tenta reenviar uma notificação.",
  "GET /api/notifications/{event_key}": "Um modelo de notificação.",
  "PUT /api/notifications/{event_key}": "Edita um modelo de notificação.",
  "POST /api/notifications/{event_key}/restore-defaults": "Volta o modelo ao padrão.",
  "GET /api/reminders": "Lembretes agendados.",
  "DELETE /api/reminders/{reminder_id}": "Cancela um lembrete.",
  "GET /api/coupons": "Lista os cupons.",
  "POST /api/coupons": "Cria um cupom.",
  "PUT /api/coupons/{coupon_id}": "Edita um cupom.",
  "DELETE /api/coupons/{coupon_id}": "Apaga um cupom.",
  "POST /api/coupons/bulk-delete": "Apaga vários cupons.",
  "GET /api/coupons/{coupon_id}/usages": "Usos de um cupom.",
  "GET /api/coupons/usages/recent": "Usos recentes de cupons.",
  "POST /api/coupons/validate": "Valida um cupom.",
  "GET /api/analytics/geography": "Clientes por país e estado.",
  "GET /api/analytics/geography/customers": "Clientes de uma região.",
  "POST /api/system/update": "Atualiza o sistema (roda o update.sh).",
  "GET /api/system/update-status": "Andamento da atualização.",
  "GET /api/queue": "Fila de envio.",
  "POST /api/queue/cancel": "Cancela envios da fila.",
  "POST /api/cron/monthly-report": "Tarefa agendada: relatório mensal.",
  "GET /api/customer-prefs/{painel_id}": "Preferências de um cliente.",
  "PUT /api/customer-prefs/{painel_id}": "Salva preferências de um cliente.",
  "GET /api/": "Identificação do serviço.",
  "GET /api/health": "Servidor no ar.",
  "GET /api/health/poller": "Verificador de pagamentos no ar.",
};

// Request bodies for endpoints that read raw JSON (no schema in OpenAPI).
export const BODY_EXAMPLES = {
  "PUT /api/raffle/settings": { enabled: true, clover_price: "2,00", prize_months: 1, joker_count: 0, joker_login: "", joker_phone: "", auto_restart: true, auto_renew: true },
  "PUT /api/raffle/participant-name": { customer_id: "227427597", name: "Nome exibido" },
  "POST /api/raffle/entries": { customer: "login_do_painel", clovers: 1 },
  "PUT /api/customer-prefs/{painel_id}": { fixed_plan: null, prices: {}, notify_events: {} },
};
